import { useCallback } from 'react'

import { useModalStore } from '@features/modal'

import { IsAdult } from '@widgets/is-adult'

import useIsAdult from './useIsAdult'

interface GuardAgeVerificationOptions {
  onCancel?: () => void;
}

export default function useAgeVerification () {
  const { isAdult } = useIsAdult()
  const { openModal } = useModalStore()

  const guardAgeRestrictedAction = useCallback((
    isAgeControlRequired: boolean,
    action: () => void | Promise<void>,
    options?: GuardAgeVerificationOptions,
  ) => {
    if (!isAgeControlRequired || isAdult) {
      void action()
      return
    }

    openModal(
      'isAdult',
      (
        <IsAdult
          onConfirm={() => {
            void action()
          }}
          onCancel={options?.onCancel}
        />
      ),
      {
        hideIconClose: true,
        onClose: options?.onCancel,
      },
    )
  }, [ isAdult, openModal ])

  return {
    isAdult,
    guardAgeRestrictedAction,
  }
}
